import React from 'react';
import { Message } from 'mage-i18n';
const Strong = value => React.createElement("strong", null, value);
export const makeSubtitleElement = (group) => group.labelSubtitle ? React.createElement(Message, { path: group.labelSubtitle, params: { strong: Strong } }) : null;
